import graphql__2a2ea11195fc1a9d82c9 from "./__generated__/AuthenticationOpenidForm_openidAuth.graphql.js";import { useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import ButtonLink from "../Buttons/ButtonLink";
import { useNavigateTo } from "../Routes/RoutesContext";

const AuthenticationOpenidForm = props => {
  const openidAuth = useFragment(AuthenticationOpenidForm_openidAuth, props.openidAuth);
  const { signInUrl, label } = openidAuth;

  const className = classNames(["form-wrapper", props.className]);
  const navigateTo = useNavigateTo();

  const handleClick = useCallback(
    e => {
      e.preventDefault();
      // Force a full HTTP navigation to the SSO endpoint instead of using
      // React Router. The OpenID flow needs to initiate server-side session
      // state (nonce, state tokens) and then redirect to the external identity
      // provider. React Router would only change the URL without making an
      // actual HTTP request, preventing the server from initializing the SSO
      // flow and performing the necessary external redirect.
      navigateTo(signInUrl, {}, { target: "_self" });
    },
    [signInUrl, navigateTo]
  );

  return (
    <div className={className} data-openid-auth-form>
      <ButtonLink
        className="btn btn-primary-inverse btn-block-md box-shadow-lg"
        href={signInUrl}
        type="button"
        label={label}
        iconClassName="icon-connexion"
        iconPosition="after"
        onClick={handleClick}
        data-choose-openid-auth-button
      />
    </div>
  );
};

const AuthenticationOpenidForm_openidAuth = graphql__2a2ea11195fc1a9d82c9;

export default AuthenticationOpenidForm;
